// API calls for authentication

export interface LoginRequest {
  email: string;
  turnstileToken: string;
}

export interface VerifyCodeRequest {
  email: string;
  code: string;
}

export interface AuthResponse {
  token: string;
  user: {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    role: 'admin' | 'client';
    walletAddress: string | null;
    createdAt: string;
  };
}

export interface User {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  role: 'admin' | 'client';
  walletAddress: string | null;
  createdAt: string;
}

export const requestLoginCode = async (data: LoginRequest): Promise<{ success: boolean; message: string }> => {
  const response = await fetch('/api/auth/request-code', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to request login code');
  }

  return response.json();
};

export const verifyLoginCode = async (data: VerifyCodeRequest): Promise<AuthResponse> => {
  const response = await fetch('/api/auth/verify-code', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to verify login code');
  }

  return response.json();
};

export const verifyToken = async (token: string): Promise<{ valid: boolean; user: User }> => {
  const response = await fetch('/api/auth/verify-token', {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to verify token');
  }

  return response.json();
};

export const refreshToken = async (token: string): Promise<AuthResponse> => {
  const response = await fetch('/api/auth/refresh-token', {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to refresh token');
  }

  return response.json();
};
